import Verbleif from "@verbleif/lib/src/plugin";
import { localeReady } from "@verbleif/lib/src/translations/i18n";
import app from "@web/core/app";
import {
  // Components
  Menu,
  options,
  Tooltip,
  vClosePopper,
  // Directives
  vTooltip,
} from "floating-vue";
import "@unovis/ts/styles";
import "animate.css";
import "@web/core/config";
import "@web/core/plugin/router";
import "@web/core/plugin/sentry";
import "@verbleif/shared/src/components/Sonner/toastDefaults";
import "@web/core/plugin/import";
import "@web/core/plugin/notifications";
import "@web/core/plugin/theme";
import "floating-vue/dist/style.css";
import "@verbleif/lib/src/global.css";
import "@verbleif/lib/src/scss/Fonts.css";

if (import.meta.env.DEV) {
  if (window.location.hostname === "localhost") {
    window.location.hostname = "verbleif.localhost";
  }
}

async function initializeApp() {
  if (import.meta.env.VITE_MOCKED === "true") {
    const { disableMercure } = await import("@verbleif/lib/src/composables/Mercure/useMercure");
    disableMercure.value = true;

    console.log("%c[MSW] Mocked is true", "color: red; font-weight: bold;");
    const { setupWorker } = await import("msw/browser");
    const { handlers, webHandlers } = await import("@verbleif/mocks/src/handlers");
    // We put ...handlers at the end because we have a * wildcard in the handlers array to prevent dynamic imports from being mocked
    await setupWorker(...webHandlers, ...handlers).start({ onUnhandledRequest: "bypass" });
  }

  options.themes["verbleif-popper"] = {
    $extend: "dropdown",
  };
  options.themes["verbleif-select"] = {
    $extend: "dropdown",
  };
  options.themes["verbleif-popper-bounded"] = {
    $extend: "dropdown",
  };

  options.themes["verbleif-tooltip"] = {
    $extend: "tooltip",
  };
  options.themes["verbleif-tooltip-gray"] = {
    $extend: "tooltip",
  };
  options.themes["verbleif-tooltip-ac"] = {
    $extend: "tooltip",
  };
  options.themes["verbleif-tooltip-dark"] = {
    $extend: "tooltip",
  };
  options.themes["verbleif-tooltip-solid"] = {
    $extend: "tooltip",
  };
  await localeReady;
  app
    .directive("tooltip", vTooltip)
    .directive("close-popper", vClosePopper)

    .component("VVTooltip", Tooltip)
    .component("VMenu", Menu)
    .use(Verbleif)
    .mount("#app");
}

initializeApp().then();
